module.exports = __webpack_public_path__ + "img/3_01.1ef8e705.jpg";